import { render, staticRenderFns } from "./Compose.PanelComposer.vue?vue&type=template&id=389d5374&scoped=true&"
import script from "./Compose.PanelComposer.vue?vue&type=script&lang=js&"
export * from "./Compose.PanelComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d5374",
  null
  
)

export default component.exports